import { render, staticRenderFns } from "./MenuListItem.vue?vue&type=template&id=b8b9a94e"
import script from "./MenuListItem.vue?vue&type=script&lang=js"
export * from "./MenuListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports